import { getAuthToken, logout } from '../../utils/auth';
import Axios from 'axios';
class BaseAPI {
    constructor() {
        BaseAPI.http = this.createAxiosInstance();
        this.interceptRequest(BaseAPI.http);
        this.interceptResponse(BaseAPI.http);
    }
    createAxiosInstance() {
        return Axios.create();
    }
    interceptRequest(apiInstance) {
        apiInstance.interceptors.request.use(config => {
            const token = getAuthToken();
            if (!!token && config.headers) {
                config.headers.authToken = token;
            }
            return config;
        }, error => {
            return Promise.reject(error);
        });
    }
    interceptResponse(apiInstance) {
        apiInstance.interceptors.response.use(response => {
            return response;
        }, error => {
            if (error?.response?.status === 401) {
                logout();
                window.location.href = `/login?otherUrl=${window.location.pathname}`;
            }
            else {
                return Promise.reject(error);
            }
        });
    }
    static getHTTPInstance() {
        if (!this.instance) {
            this.instance = new BaseAPI();
        }
        return BaseAPI.http;
    }
}
const server = BaseAPI.getHTTPInstance();
const API = {
    withMetadata: (metadata) => {
        return {
            post: (url, data, config) => {
                return server.post(url, { ...data, ...metadata }, config);
            },
            put: (url, data, config) => {
                return server.put(url, { ...data, ...metadata }, config);
            },
        };
    },
    get: (url, config) => {
        return server.get(url, config);
    },
    post: (url, data, config) => {
        return server.post(url, data, config);
    },
    put: (url, data, config) => {
        return server.put(url, data, config);
    },
    delete: (url, config) => {
        return server.delete(url, config);
    },
};
export { API };
